import { isPlaybookDisabled } from '@ion/api';

// blockDisabled defaults on so a consumer that forgets the flag can't offer a
// disabled revision as a deploy target; filter dropdowns opt out to stay selectable.
export default function buildRevisionOptions(playbooks, { blockDisabled = true } = {}) {
  return playbooks.map(playbook => {
    const isDisabled = isPlaybookDisabled(playbook);

    return {
      value: playbook.id,
      label: isDisabled ? `Revision ${playbook.revision} (disabled)` : `Revision ${playbook.revision}`,
      disabled: blockDisabled && isDisabled,
    };
  });
}
